import { useState, useEffect, useContext } from "react";
import { Form, Table, Tabs } from "antd";
import { useLocation } from "react-router-dom";
import "./forms.css";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { JsonToExcel } from "react-json-to-excel";
import { exportJson } from "../../../utils/export";
import CustomLoader from "../../common/customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import SendForm from "./sendForm";
import media from "../../../media";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSendFormsThunk } from "../../../store/thunks/sendFormsThunk";
import TableContent from "../../../components/atoms/TableContent";

const { TabPane } = Tabs;
const SendForms = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const currentPath = location.pathname.replace("/", "");
  const [tableForm] = Form.useForm();

  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.vocSendForms,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;

  const [showLoader, setShowLoader] = useState(true);
  const [selectionType, setSelectionType] = useState("checkbox");
  const [tab, setTab] = useState("1");

  const [selectedRowsArray, setSelectedRowsArray] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  const openAddModal = () => {
    setEditRecord(null);
    setModalOpen(true);
  };
  {
    /*Defining columns for Voc - Forms Listing*/
  }
  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            ID
          </div>
        );
      },
      dataIndex: "_id",
      render: (text) => <span className="rowStyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            Form Name
          </div>
        );
      },
      dataIndex: "formDisplayName",
      render: (text, row) => {
        return (
          <span className="rowStyle no-wrap">
            {row?.formName?.formDisplayName || "-"}
          </span>
        );
      },
    },
    ,
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentName.svg} alt="icon" />
            Recipient
          </div>
        );
      },
      dataIndex: "recipient",

      render: (_, row) => {
        const recipients = row?.recipients || [];
        if (!recipients.length) return <span>-</span>;

        const email = recipients[0];
        const firstLetter = email.charAt(0).toUpperCase();

        return (
          <span className="rowStyle no-wrap profileText">
            <span className="firstCaps">{firstLetter}</span>
            {email}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />
            Status
          </div>
        );
      },
      dataIndex: "status",
      render: (text, row) => (
        <span
          className={`cusStatus ${
            text?.toLowerCase() === "active" ? "cusActive" : "cusInActive"
          }`}
        >
          {text}
        </span>
      ),
    },

    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            {tab === "1" ? "Created On" : "Captured On"}
          </div>
        );
      },
      dataIndex: tab === "1" ? "created_at" : "updated_at",

      render: (_, row) => {
        const date = tab === "1" ? row?.createdAt : row?.updatedAt;

        return (
          <span className="rowStyle no-wrap">
            {date ? moment(date).format("ddd, DD MMM YYYY HH:mm:ss") : "-"}
          </span>
        );
      },
    },
  ];

  /*begin::getSendFormsList will fetch list of SendForms*/

  {
    /*Export functionality on VOC Form Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      setGlobalState((prev) => ({
        ...prev,
        selectedRowKeysChildInfo: selectedRowKeys,
        selectedRowKeys: selectedRows.map((row) => row.id),
        exportFormsJson: selectedRows,
      }));
      const exportColumns = [
        { key: "Form Name", path: "formName.formDisplayName" },
        {
          key: "Recipients",
          path: "recipients",
          formatter: (value) => (value ? value.toString() : ""),
        },
        { key: "Status", path: "status" },
      ];

      // Depending on the value of 'tab', add additional columns
      if (tab === "1") {
        exportColumns.push({
          key: "Created At",
          path: "createdAt",
          formatter: (value) =>
            value ? moment(value).format("ddd, DD MMM YYYY HH:mm:ss") : "",
        });
      } else if (tab === "2") {
        exportColumns.push({
          key: "Captured On",
          path: "updatedAt",
          formatter: (value) =>
            value ? moment(value).format("ddd, DD MMM YYYY HH:mm:ss") : "",
        });
      }
      exportJson(
        selectedRows,
        globalState?.formLists,
        "Forms",
        exportColumns,
        setGlobalState,
        globalState,
      );
    },
  };

  {
    /*VForm Complete and Delete action*/
  }

  const handleTabChange = (key) => {
    setTab(key);
    secureLocalStorage.setItem("tab", key);
    //getSendFormsList("", "", key);
  };

  // Fetch Forms List
      const fetchData = async () => {
      try {
        setShowLoader(true);
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchSendFormsThunk({
            selectedRowsArray: selectedRowsArray,
            setSelectedRowsArray: setSelectedRowsArray,
            searchIn: "sendForms",
            callActionFrom: "sendForms",
            hasSearchedValue,
            searchKeyword,
            route: "sendForms",
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },

            tab: secureLocalStorage.getItem("tab")
              ? secureLocalStorage.getItem("tab")
              : 1,
          }),
        ).unwrap();
      } catch (err) {
        console.error("Error fetching audits:", err);
      } finally {
        setShowLoader(false);
      }
    };

  useEffect(() => {
    fetchData();
  }, [currentPath, pagination.current, pagination.pageSize, tab]);

  const tabChildern = tab && (
    <>
      {/*Export and Delete buttons*/}
      <div className="right-buttons">
        {(secureLocalStorage.getItem("role") === "admin" ||
          secureLocalStorage.getItem("role") === "auditor" ||
          secureLocalStorage.getItem("role") === "qc") && (
          <>
            {globalState.selectedRowKeysChildInfo &&
              globalState.selectedRowKeysChildInfo.length > 0 && (
                <JsonToExcel
                  title="Download as Excel"
                  data={globalState.exportFormsJson}
                  fileName="form"
                  btnClassName="defaultBtn defaultGreyBtn"
                />
              )}
          </>
        )}
      </div>
      {/* <Divider /> */}
      <Form form={tableForm} component={false}>
        <TableContent
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          bordered={false}
          columns={columns}
          dataSource={list}
          pagination={tablePagination}
        />
      </Form>
    </>
  );
  return (
    <div className="all-content">
      <CustomLoader showLoader={showLoader} />
      <TopContainerHeader
        sectionTitle="Forms"
        sectionDescription={showLoader ? "Loading..." : `${count || 0} Found`}
        hasSectionButton={true}
        sectionButtons={[
          {
            isVisible: true,
            itemType: "",
            itemName: "Send Forms",
            onClick: openAddModal,
          },
        ]}
        hasFilter={false}
        buttonTitle="Send Forms"
        FormComponent={(props) => (
                        <SendForm
                          {...props}
                          onSuccess={() => {
                            fetchData();        // refresh list
                            setModalOpen(false); // close modal
                          }}
                        />
        )}
        formTitle={"Send Form"}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />

      <div className="all-table-holder">
        <CustomLoader showLoader={showLoader} />

        <div className="forms-buttons">
          {/* Define individual tabs using TabPane */}
          <Tabs
            defaultActiveKey="1"
            onChange={handleTabChange}
            items={[
              {
                label: (
                  <span>
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>{" "}
                    Created Forms
                  </span>
                ),
                key: "1",
                children: tabChildern,
              },
              {
                label: (
                  <span>
                    <i className="fa fa-file-text-o" aria-hidden="true"></i>{" "}
                    Submitted Forms
                  </span>
                ),
                key: "2",
                children: tabChildern,
              },
            ]}
            className="w-100"
          />
        </div>
      </div>
    </div>
  );
};
export default SendForms;
